<template>
  <div class="list-trade-in">
    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>
    <KTCodePreview v-bind:title="'Danh sách phiếu định giá'">
      <template v-slot:toolbar>
        <div class="row" v-if="checkPermission('TRADE_IN_SHOW_ALL_STORE')">
          <div>
            <b-dropdown size="sm" id="dropdown-1" right>
              <template slot="button-content">
                <i class="fas fa-cog cog-font-size"></i>
                <span class="font-weight-bolder">Thao tác</span>
              </template>
              <b-dropdown-item @click="excelModal">
                <span>
                  <i class="far fa-file-excel excel-font-size"></i>
                  &nbsp; Xuất Excel</span
                >
              </b-dropdown-item>
              <b-dropdown-item @click="reportSummaryClick">
                <span>
                  <i class="far fa-file-excel excel-font-size"></i>
                  &nbsp; Xuất Excel tổng hợp</span
                >
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </template>
      <template v-slot:preview>
        <b-row>
          <b-col>
            <div class="d-flex justify-content-center align-items-center">
              <b-input-group>
                <date-picker
                  placeholder="Từ ngày"
                  class="form-control form-control-sm"
                  :config="dpConfigs.date"
                  v-model="dateFrom"
                ></date-picker>
              </b-input-group>
              <span class="ml-1 mr-1"></span>
              <b-input-group>
                <date-picker
                  placeholder="Tới ngày"
                  class="form-control form-control-sm"
                  :config="dpConfigs.date"
                  v-model="dateTo"
                ></date-picker>
              </b-input-group>
            </div>
          </b-col>
          <b-col v-if="checkPermissions(['TRADE_IN_SHOW_ALL_STORE'])">
            <BDropdownCustom
              v-model="valueStore"
              :options="filterdOptionsStore"
              :placeholder="'cửa hàng'"
              :searchable="true"
              :matchKey="['name']"
              :limit="5"
            />
          </b-col>
          <b-col>
            <div class="d-flex justify-content-start">
              <b-input
                placeholder="Tìm kiếm theo tên, mã, IMEI sản phẩm"
                v-model="searchProduct"
                class="form-control form-control-sm"
                v-on:keyup.enter="onFilter()"
              ></b-input>
            </div>
          </b-col>
          <b-col>
            <b-input
              placeholder="Tìm kiếm theo tên, SĐT KH"
              v-model="searchCustomer"
              class="form-control form-control-sm"
              v-on:keyup.enter="onFilter()"
            ></b-input>
          </b-col>
          <b-col>
            <b-form-select
              class="select-style"
              size="sm"
              v-model="selectedStatus"
              :options="listStatus"
              value-field="id"
              text-field="name"
            >
              <template v-slot:first>
                <b-form-select-option :value="null" disabled
                  >-- Trạng thái --
                </b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col>
            <b-form-input
              v-model="searchId"
              type="text"
              placeholder="Mã phiếu"
              size="sm"
              v-on:keyup.enter="onFilter()"
            ></b-form-input>
          </b-col>
          <b-col>
            <b-form-select
              class="select-style"
              size="sm"
              v-model="selectedType"
              :options="listType"
              value-field="id"
              text-field="name"
            >
              <template v-slot:first>
                <b-form-select-option :value="null" disabled>
                  -- Loại phiếu --
                </b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
          <b-col></b-col>
          <b-col></b-col>
          <b-col></b-col>
        </b-row>
        <b-row class="mb-5 mt-4">
          <b-col md="1">
            <b-button
              class="function-btn"
              variant="primary"
              size="sm"
              @click="onFilter"
              >Lọc
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-table
              :items="items"
              :fields="fields"
              hover
              bordered
              :busy="onLoading"
              responsive
              class="w-100"
            >
              <template v-slot:table-busy>
                <vcl-table :speed="5" :animate="true" :columns="6"></vcl-table>
              </template>
              <template v-slot:cell(id)="row">
                <div class="text-center">
                  <div
                    class="productCode btn-link cursor-pointer"
                    @click="editItem(row.item)"
                  >
                    <span v-text="row.item.id"></span>
                  </div>

                  <div class="mb-1">
                    <i
                      :class="getTradeInTypeIcon(row.item.tradeInType)"
                      class="icon-color text-dark"
                      v-b-tooltip.hover
                      :title="row.item.tradeInTypeName"
                    ></i>
                  </div>
                </div>
              </template>
              <template v-slot:cell(createdBy)="row">
                <span class="font-weight-bolder">{{ row.item.createdBy }}</span><br/>
                <span class="text-muted text-small">{{ row.item.date }}</span>
              </template>
              <template v-slot:cell(customer)="row">
                <p class="mb-0 font-weight-bolder">
                  {{ row.item.customerName }}
                </p>
                <p class="mb-0">
                  <a
                    class="font-weight-bold cursor-pointer"
                    @click="editUser(row.item)"
                  >
                    {{ row.item.customerPhone }}
                  </a>
                </p>
              </template>
              <template v-slot:cell(productName)="row">
                <div class="d-flex align-items-center flex-gap-8">
                  <!-- Product Image -->
                  <ProductImage
                    :src="row.item.productImageUrl"
                    class="size-40 object-contain flex-shrink-0"
                  />

                  <!-- Product Information -->
                  <div class="flex-grow-1 min-w-0">
                    <p class="m-0 text-medium text-11 lh-1-4">
                      {{ row.item.productBarCode }}
                    </p>
                    <p class="m-0 text-medium text-12 lh-1-4">
                      {{ row.item.productCode }}
                    </p>
                    <p class="m-0 font-weight-bolder lh-1-4">
                      {{ row.item.productName }}
                    </p>
                    <p class="text-imei-no m-0">
                      IMEI: {{ row.item.imeiCode }}
                    </p>
                  </div>
                </div>
              </template>
              <template v-slot:cell(estimatePrice)="row">
                <div>
                  <span v-text="convertPrice(row.item.estimatePrice)"></span>
                </div>
              </template>
              <template v-slot:cell(finalPrice)="row">
                <div>
                  <span
                    class="font-weight-bolder"
                    v-text="convertPrice(row.item.finalPrice)"
                  ></span>
                  <div v-if="row.item.differencePrice !== 0" class="mt-1">
                    <span
                      :class="getDifferenceClass(row.item.differencePrice)"
                      class="text-small"
                    >
                      <i
                        :class="getDifferenceIcon(row.item.differencePrice)"
                        class="mr-1"
                      ></i>
                      <span
                        v-text="formatDifference(row.item.differencePrice)"
                      ></span>
                    </span>
                  </div>
                </div>
              </template>
              <template v-slot:cell(hasUploadImage)="row">
                <div>
                  <span
                    v-bind:class="getUploadClass(row.item.hasUploadImage)"
                    >{{ row.item.hasUploadImage }}</span
                  >
                </div>
              </template>
              <template v-slot:cell(statusName)="row">
                <div class="text-center">
                  <div class="mb-2">
                    <span
                      v-if="row.item.status === 1"
                      v-text="row.item.statusName"
                      class="label font-weight-bolder label-lg label-light-success label-inline note"
                    ></span>
                    <span
                      v-else
                      v-text="row.item.statusName"
                      class="label font-weight-bolder label-lg label-light-info label-inline note"
                    ></span>
                  </div>
                  <div>
                    <b-link
                      v-if="row.item.stockSlipCode"
                      v-text="row.item.stockSlipCode"
                      @click="updateImportTradeIn(row.item)"
                      class="text-sm mt-1 cursor-pointer"
                    ></b-link>
                  </div>
                  <div>
                    <span v-if="row.item.billNumber">
                      Số HD:
                      <span
                        class="text-primary cursor-pointer"
                        @click="viewBill(row.item.billNumber)"
                      >
                        {{ row.item.billNumber }}
                      </span>
                    </span>
                  </div>
                </div>
              </template>
              <template v-slot:cell(actions)="row">
                <div class="d-flex justify-content-center">
                  <b-dropdown size="sm" id="dropdown-left" no-caret right>
                    <template slot="button-content">
                      <i class="flaticon2-settings settings-font-size pr-0"></i>
                    </template>
                    <b-dropdown-item @click="printItem(row.item)">
                      <span style="color: #3f4254; font-size: 12px">
                        <i
                          style="font-size: 1rem"
                          class="flaticon2-printer"
                        ></i>
                        &nbsp; In phiếu
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="editItem(row.item)">
                      <span class="text-sm">
                        <i class="flaticon-eye eye-font-size"></i>
                        &nbsp; Chi tiết
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="importTradeIn(row.item)">
                      <span class="text-sm">
                        <i class="flaticon2-pen pen-font-size"></i>
                        &nbsp; Nhập máy cũ
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item 
                      @click="createWarranty(row.item)"
                      v-if="
                        checkPermission('WARRANTY_RECEPTION_INSERT') &&
                        row.item.status === TRADE_IN_STATUS.QUOTE
                      "
                    >
                      <span class="text-sm">
                        <i
                          style="font-size: 1rem"
                          class="fas fa-toolbox"
                        ></i>
                        &nbsp; Tạo phiếu tiếp nhận bảo hành
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="
                        showDeleteAlert(
                          modalTitle,
                          modalDesc,
                          row.item,
                          deleteFn,
                        )
                      "
                      v-if="
                        checkPermission('TRADE_IN_DELETE') &&
                        row.item.status === TRADE_IN_STATUS.QUOTE
                      "
                    >
                      <span class="text-sm">
                        <i
                          style="color: #d33"
                          class="flaticon2-rubbish-bin-delete-button pen-font-size"
                        ></i>
                        &nbsp; Xóa
                      </span>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>
            </b-table>
            <b-row>
              <b-col>
                <p class="mt-3 text-dark font-weight-bold">
                  Tổng số:
                  {{ convertPrice(totalRow) }}
                </p>
              </b-col>
              <b-col>
                <b-pagination-nav
                  :link-gen="linkGen"
                  v-show="numberOfPage >= 2"
                  :number-of-pages="numberOfPage"
                  use-router
                  @change="fetchData"
                  align="right"
                  class="custom-pagination"
                >
                  <template v-slot:first-text>
                    <span>
                      <i class="ki ki-bold-double-arrow-back icon-xs"></i>
                    </span>
                  </template>

                  <template v-slot:prev-text>
                    <i class="ki ki-bold-arrow-back icon-xs"></i>
                  </template>

                  <template v-slot:next-text>
                    <i class="ki ki-bold-arrow-next icon-xs"></i>
                  </template>

                  <template v-slot:last-text>
                    <span class="text-info">
                      <i class="ki ki-bold-double-arrow-next icon-xs"></i>
                    </span>
                  </template>
                </b-pagination-nav>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </template>
    </KTCodePreview>
    <b-modal ref="excel-modal" hide-footer title="Xuất excel" id="excel-modal">
      <v-form ref="form" lazy-validation>
        <div class="mb-4">
          <div class="row">
            <div class="col-6">
              <b-form-group label="Danh sách cần xuất:">
                <b-form-radio-group
                  v-model="selectedListExcel"
                  name="radio-sub-component-2"
                >
                  <b-form-radio value="all">Tất cả các trang</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>
          </div>
        </div>

        <b-button variant="primary" size="sm" @click="reportClick" class="mr-3">
          <v-icon small class="text-white" v-b-tooltip>mdi-download</v-icon>
          <strong>Xuất Excel</strong>
        </b-button>

        <b-button
          variant="secondary"
          size="sm"
          @click="$bvModal.hide('excel-modal')"
        >
          <strong>Hủy</strong>
        </b-button>
      </v-form>
    </b-modal>
  </div>
</template>
<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import localData from '@/utils/saveDataToLocal';
import { VclTable } from 'vue-content-loading';
import moment from 'moment';
import axios from 'axios';
import {
  BASE_URL,
  TRADE_IN_TYPE as TRADE_IN_TYPE_SELECT,
} from '@/utils/constants';
import { checkPermissions } from '@/utils/saveDataToLocal';
import fileDownload from '@/utils/file-download';
import { cloneDeep, map, find, assign } from 'lodash';
import {
  removeAccents,
  convertPrice,
  makeToastSuccess,
  makeToastFaile,
} from '@/utils/common';
import { getToastInstance } from '@/utils/toastHelper';
import { mapGetters } from 'vuex';
import Loader from '@/view/content/Loader.vue';
import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue';
import ProductImage from '@/view/components/products/ProductImage.vue';
import { TRADE_IN_TYPE, TRADE_IN_STATUS } from '@/utils/enum';
import { showDeleteAlert } from '@/utils/sweet-alert2';
import { convertToDateSlash } from '@/utils/date';

export default {
  data() {
    return {
      selectedType: null,
      listType: TRADE_IN_TYPE_SELECT,
      TRADE_IN_STATUS,
      modalTitle: 'Xoá phiếu',
      modalDesc: 'Xoá phiếu định giá',
      TRADE_IN_TYPE,
      searchProduct: '',
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: false,
          thClass: 'table-header-id',
        },
        {
          key: 'storeName',
          label: 'Cửa hàng',
          sortable: false,
          tdClass: 'td-store-name',
          thClass: 'table-header-store',
        },
        {
          key: 'customer',
          label: 'Khách hàng',
          sortable: false,
          tdClass: 'td-customer',
          thClass: 'table-header-customer',
        },
        {
          key: 'productName',
          label: 'Tên sản phẩm',
          sortable: false,
          tdClass: 'td-product-name',
          thClass: 'table-header-product',
        },
        {
          key: 'estimatePrice',
          label: 'Giá thu dự kiến',
          sortable: false,
          tdClass: 'td-estimate-price',
          thClass: 'table-header-estimate',
        },
        {
          key: 'finalPrice',
          label: 'Giá thu cuối cùng',
          sortable: false,
          tdClass: 'td-final-price',
          thClass: 'table-header-final',
        },
        {
          key: 'note',
          label: 'Ghi chú',
          sortable: false,
          tdClass: 'td-note',
          thClass: 'table-header-note',
        },
        {
          key: 'statusName',
          label: 'Trạng thái',
          sortable: false,
          tdClass: 'td-status',
          thClass: 'table-header-status',
        },
        {
          key: 'createdBy',
          label: 'Người tạo',
          sortable: false,
          tdClass: 'td-created-by',
          thClass: 'table-header-created-by text-center',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'table-header-actions',
          tdClass: 'td-functions',
        },
      ],
      items: [],
      linkGen: (pageNum) => {
        return pageNum === 1 ? '?' : `?page=${pageNum}`;
      },
      page: 1,
      numberOfPage: 1,
      totalRow: 1,
      onLoading: false,
      searchCustomer: '',
      dpConfigs: {
        date: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      dateFrom: '',
      dateTo: '',
      selectedListExcel: 'all',
      optionsStore: [],
      valueStore: [],
      listStatus: [
        {
          id: null,
          name: 'Chọn trạng thái',
        },
        {
          id: 1,
          name: 'Đã báo giá',
        },
        {
          id: 2,
          name: 'Đã thu cũ',
        },
      ],
      selectedStatus: null,
      searchId: '',
      filterdOptionsStore: [],
    };
  },
  components: {
    KTCodePreview,
    VclTable,
    Loader,
    BDropdownCustom,
    ProductImage,
  },
  created() {
    this.fetchStore();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Phiếu định giá', route: 'trade-in' },
      { title: 'Danh sách phiếu định giá' },
    ]);
  },
  methods: {
    checkPermissions,
    viewBill(billNumber) {
      if (!billNumber) {
        return;
      }
      const routeData = this.$router.resolve({
        name: 'update-bill',
        query: { id: billNumber },
      });
      window.open(routeData.href, '_blank');
    },
    deleteFn(item) {
      ApiService.delete(`/v1/trade-ins/${item.id}`)
        .then(({ data }) => {
          if (data.status === 200) {
            makeToastSuccess(data.message);
            this.fetchData();
          } else {
            makeToastFaile(data.message);
          }
        })
        .catch(({ response }) => {
          const { status, message } = response.data;
          if (status === 0) {
            makeToastFaile(message);
          }
        });
    },
    showDeleteAlert,
    getUploadClass(text) {
      return text === 'Chưa tải lên' ? 'text-danger' : 'text-success';
    },
    getTradeInTypeIcon(tradeInType) {
      switch (tradeInType) {
        case TRADE_IN_TYPE.TRADE_IN:
          return 'fa fa-retweet';
        case TRADE_IN_TYPE.BUYING_OLD_ITEMS:
          return 'fa fa-cart-arrow-down';
        case TRADE_IN_TYPE.EXCHANGE_WARRANTY:
          return 'fa fa-shield-alt';
        case TRADE_IN_TYPE.TEST_IMEI:
          return 'fa fa-mobile-alt';
        default:
          return 'fa fa-question-circle';
      }
    },
    getDifferenceClass(difference) {
      if (difference > 0) {
        return 'text-success';
      } else if (difference < 0) {
        return 'text-danger';
      }
      return 'text-muted';
    },
    getDifferenceIcon(difference) {
      if (difference > 0) {
        return 'fas fa-arrow-down';
      } else if (difference < 0) {
        return 'fas fa-arrow-up';
      }
      return 'fas fa-minus';
    },
    formatDifference(difference) {
      const absValue = Math.abs(difference);
      const formatted = this.convertPrice(absValue);
      if (difference === 0) {
        return formatted;
      }
      const sign = difference > 0 ? '-' : '+';
      return `${sign}${formatted}`;
    },
    printItem(item) {
      this.$router.push({
        name: 'print-import-trade-in',
        query: { id: item.id, type: 1 },
      });
    },
    createWarranty(item) {
      if (!item.id) return;
      const routeData = this.$router.resolve({
        name: 'warranty-reception-info',
        query: { action: 'create', tradeInId: item.id },
      });
      window.open(routeData.href, '_blank');
    },
    convertPrice,
    convertToDateSlash,
    ...getToastInstance(),
    fetchData: async function () {
      this.onLoading = true;
      this.page = this.$route.query.page;
      if (!this.page) {
        this.page = 1;
      }
      const fromDate = this.dateFrom
        ? moment(this.dateFrom, 'DD/MM/YYYY').format('yyyy-MM-DD 00:00:00')
        : null;
      const toDate = this.dateTo
        ? moment(this.dateTo, 'DD/MM/YYYY HH:mm').format('yyyy-MM-DD 23:59')
        : null;
      let listStoreId = [];
      if (
        this.checkPermission('TRADE_IN_SHOW_ALL_STORE') &&
        this.valueStore.length
      ) {
        listStoreId = this.valueStore.map(({ code }) => code);
      }
      const param = {
        page: this.page,
        limit: 10,
        searchProduct: this.searchProduct ? this.searchProduct.trim() : '',
        searchCustomer: this.searchCustomer ? this.searchCustomer.trim() : '',
        fromDate: fromDate,
        toDate: toDate,
        store: listStoreId,
        selectedStatus: this.selectedStatus,
        searchId: this.searchId ? this.searchId.trim() : '',
        type: this.selectedType,
      };
      const paramQuery = {
        params: param,
      };
      ApiService.query('/v1/trade-ins', paramQuery).then(({ data }) => {
        this.numberOfPage = data.data.totalPage;
        this.totalRow = data.data.totalRow;
        this.items = data.data.data.map((element) => {
          return {
            id: element.id,
            customerId: element.customerId,
            customerName: element.customerName,
            customerPhone: element.customerPhoneNo,
            productName: element.productName,
            productCode: element.productCode,
            productBarCode: element.productBarCode,
            productImageUrl: element.productImageUrl,
            imeiCode: element.productIMEI,
            estimatePrice: element.estimationBuyingPrice,
            finalPrice: element.finalBuyingPrice,
            differencePrice:
              element.estimationBuyingPrice - element.finalBuyingPrice,
            date: convertToDateSlash(element.createdAt),
            storeName: element.storeName,
            status: element.status,
            createdBy: element.createdBy,
            statusName: element.statusName,
            tradeInType: element.tradeInType,
            tradeInTypeName: element.tradeInTypeName,
            stockSlipCode: element.stockSlipCode,
            stockSlipId: element.stockSlipId,
            note: element.note,
            hasUploadImage: element.hasUploadImage,
            billNumber: element.billNumber || '',
          };
        });
      });
      this.onLoading = false;
    },
    editItem: function (item) {
      this.$router.push({
        name: 'update-trade-in',
        query: { id: item.id },
      });
    },
    updateImportTradeIn: function (item) {
      const { href } = this.$router.resolve({
        name: 'update-import-trade-in',
        query: { id: item.stockSlipId },
      });
      window.open(href, '_blank');
    },
    importTradeIn: function (item) {
      const { href } = this.$router.resolve({
        name: 'import-trade-in',
        query: { id: item.id },
      });
      window.open(href, '_blank');
    },
    checkPermission: function (condition) {
      return localData.checkPermission(condition);
    },
    onFilter() {
      this.$route.query.page = 1;
      this.$router.push({
        name: 'list-trade-in',
      });
      this.fetchData();
    },
    excelModal: async function () {
      this.$refs['excel-modal'].show();
    },
    buildExcelParams() {
      const fromDate = this.dateFrom
        ? moment(this.dateFrom, 'DD/MM/YYYY').format('yyyy-MM-DD')
        : null;
      const toDate = this.dateTo
        ? moment(this.dateTo, 'DD/MM/YYYY HH:mm').format('yyyy-MM-DD 23:59')
        : null;
      const listStoreId = [];
      if (
        this.checkPermission('TRADE_IN_SHOW_ALL_STORE') &&
        this.valueStore.length
      ) {
        this.valueStore.forEach((element) => {
          listStoreId.push(element.code);
        });
      }
      return {
        searchProduct: this.searchProduct,
        searchCustomer: this.searchCustomer,
        fromDate: fromDate,
        toDate: toDate,
        storeIds: listStoreId,
        status: this.selectedStatus,
        searchId: this.searchId ? this.searchId.trim() : '',
        type: this.selectedType,
      };
    },
    downloadExcel(url) {
      axios
        .get(url, {
          params: {
            ...this.buildExcelParams(),
          },
          responseType: 'blob',
        })
        .then((response) => {
          const fileName = fileDownload.getFileName(response);
          fileDownload.createFile(response.data, fileName);
        })
        .catch((err) => {
          console.log('err', err);
          if (!err.response) {
            this.makeToastFailure('Lỗi!');
          } else {
            const message = err.response.data.message;
            this.makeToastFailure(message);
          }

          this.$nprogress.done();
        });
    },
    reportClick: async function () {
      this.downloadExcel(`${BASE_URL}v1/trade-ins/export-excel`);
    },
    reportSummaryClick: async function () {
      this.downloadExcel(`${BASE_URL}v1/trade-ins/export-excel-summary`);
    },
    onSelectStore(option) {
      let index = this.optionsStore.findIndex(
        (item) => item.name == option.name,
      );
      this.optionsStore[index].checked = true;
      this.filterdOptionsStore = cloneDeep(this.optionsStore);
    },

    onRemoveStore(option) {
      let index = this.optionsStore.findIndex(
        (item) => item.name == option.name,
      );
      this.optionsStore[index].checked = false;
      this.filterdOptionsStore = cloneDeep(this.optionsStore);
    },
    onInputStoreChange(textInput = '') {
      this.searchStore(textInput);
    },
    searchStore(textInput) {
      let options = cloneDeep(this.optionsStore);
      if (!textInput || !textInput.trim().length) {
        this.filterdOptionsStore = map(options, (obj) => {
          return assign(obj, find(this.filterdOptionsStore, { id: obj.id }));
        });
        return;
      }

      const indexChooseAll = options.findIndex((prop) => prop.id === -1);

      if (indexChooseAll > -1) {
        options.splice(indexChooseAll, 1);
      }

      options = map(options, (obj) => {
        return assign(obj, find(this.filterdOptionsStore, { id: obj.id }));
      });

      this.filterdOptionsStore = this.filterOptionsBy(
        options,
        textInput,
        'name',
        10,
      );
    },
    filterOptionsBy(items, textInput, prop, limit) {
      return cloneDeep(items)
        .filter((item) => {
          if (item) {
            const nameWTUnicode = removeAccents(item[prop] || '');
            const nameInputWTUnicode = removeAccents(textInput);
            const index = nameWTUnicode
              .toLowerCase()
              .indexOf(nameInputWTUnicode.toLowerCase());

            if (index > -1) {
              return true;
            }
          }
          return false;
        })
        .slice(0, limit);
    },
    fetchStore: async function () {
      this.optionsStore = [];
      ApiService.get(`/stores/getStores`).then((response) => {
        const stores = response.data.data;
        stores.map((element) => {
          let option = {
            code: element.id,
            name: element.name,
            shortName: element.shortName,
            checked: false,
          };
          this.optionsStore.push(option);
        });
        this.filterdOptionsStore = cloneDeep(this.optionsStore);
        this.fetchStoreByUser();
      });
    },
    fetchStoreByUser() {
      ApiService.get(`/v1/stores/get-by-user`).then(({ data }) => {
        this.optionsStore = [];
        const stores = data.data.stores;
        stores.forEach((element) => {
          const option = {
            code: element.id,
            name: element.name,
            shortName: element.shortName,
            checked: false,
          };
          this.optionsStore.push(option);
          if (!data.data.viewAll) {
            const index = this.optionsStore.findIndex(
              (item) => item.code == element.id,
            );
            if (index > -1) {
              this.optionsStore[index].checked = true;
              this.valueStore.push(this.optionsStore[index]);
            }
          }
        });
        this.filterdOptionsStore = cloneDeep(this.optionsStore);
        this.fetchData();
      });
    },
    editUser: function (item) {
      this.$router.push({
        name: 'update-customer',
        query: { id: item.customerId, phoneNo: item.customerPhone },
      });
    },
    getLinkDocCustomer(item) {
      return `#/customers/update-customer?id=${item.customerId}&phoneNo=${item.customerPhone}`;
    },
  },
  computed: {
    ...mapGetters(['breadcrumbs', 'pageTitle', 'layoutConfig']),
    loaderEnabled() {
      return !/false/.test(this.layoutConfig('loader.type'));
    },
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig('loader.logo');
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/sass/components/_variables.bootstrap.scss';
@import 'src/assets/sass/components/_variables.custom.scss';

.list-trade-in ::v-deep {
  .btn.btn-icon.btn-sm,
  .btn-group-sm > .btn.btn-icon {
    height: calc(1.35em + 1.1rem + 2px);
    width: auto;
  }

  .icon:hover {
    background-color: $primary-icon-hover;
  }

  .table-header,
  .table-functions-header {
    text-align: center;
  }

  .table-header {
    width: 8%;
  }

  .table-header-id {
    text-align: center;
    width: 4%;
  }

  .table-functions-header {
    font-weight: $font-weight-bolder;
    color: $dark-75;
    width: 5%;
  }

  .table-header-store {
    text-align: center;
    width: 8%;
  }

  .table-header-customer {
    text-align: center;
    width: 8%;
  }

  .table-header-product {
    text-align: center;
    width: 26%;
  }

  .table-header-estimate {
    text-align: center;
    width: 8%;
  }

  .table-header-final {
    text-align: center;
    width: 8%;
  }

  .table-header-note {
    text-align: center;
    width: 12%;
  }

  .table-header-status {
    text-align: center;
    width: 10%;
  }

  .table-header-created-by {
    text-align: center;
    width: 10%;
  }

  .table-header-actions {
    text-align: center;
    font-weight: $font-weight-bolder;
    color: $dark-75;
    width: 5%;
  }

  .td-customer {
    width: fit-content;
  }

  .td-product-name {
    width: fit-content;
  }

  .td-estimate-price,
  .td-final-price {
    width: fit-content;
    text-align: end;
  }

  .td-note {
    min-width: 100px;
  }

  .note {
    font-size: $font-size-sm;
    white-space: -moz-pre-wrap !important; /* Mozilla, since 1999 */
    white-space: -webkit-pre-wrap; /* Chrome & Safari */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    white-space: pre-wrap; /* CSS3 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
    word-break: break-word;
    white-space: normal;
  }

  .td-status {
    max-width: 120px;
    min-width: 100px;
  }

  .td-store-name {
    width: fit-content;
  }

  .text-imei-no {
    font-size: $font-size-sm;
    font-style: italic;
    color: $primary;
  }

  .text-small {
    font-size: 0.75rem;
    font-weight: 500;
  }

  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: middle;
    border-top: 1px solid $gray-200;
  }

  .table.b-table.table-sm
    > thead
    > tr
    > [aria-sort]:not(.b-table-sort-icon-left),
  .table.b-table.table-sm
    > tfoot
    > tr
    > [aria-sort]:not(.b-table-sort-icon-left) {
    background-position: right calc(1.5rem / 2) center;
    padding-right: calc(0.3rem + 0.65em);
  }

  .productCode:hover {
    text-decoration: underline;
  }

  .icon-color {
    color: $gray-700;
  }

  .checkbox-label {
    display: block;
  }

  .function-btn {
    font-weight: $font-weight-bolder;
    width: 70px;
  }

  .td-functions {
    width: fit-content;
  }

  .cog-font-size,
  .excel-font-size,
  .settings-font-size,
  .eye-font-size,
  .pen-font-size {
    font-size: $font-size-base;
  }
}
</style>
